import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CapituloUnoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "CapituloUnoPage",
            ss: ss,
            ajax: {
                // fuerza tipo=2024 en la URL
                url: `${ss.indexArchivoCapitulo()}?tipo=2024`,
                headers: ss.getToken(),
                // y también en el payload que manda DataTables
                data: function (d) {
                    d.idEspecialidad = 0;
                    d.tipo = 2024;
                }
            },
            columns: [
                { data: 'idEspecialidad', name: 'idEspecialidad', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Especialidad', name: 'Especialidad', title: 'Especialidad' },
                { data: 'NivelAcad', name: 'NivelAcad', title: 'Nivel Académico' },
                { data: 'action', orderable: false, title: 'Cargar Archivo', searchable: false },
            ],
            especialidad: {},
            usuario: {},
            competenciaProfesionalSelect: {},
            competenciaGeneral: {},
            competenciaArea: {},
            competenciaEspecifica: {},
            competenciaInstrumental: {},
            competenciasArea: [],
            competenciasEspecificas: [],
            competenciasInstrumentales: [],
            competenciaInstrumentalCCP: [],
            especialidadesSAGA: [],
            nombreEspecialidad: '',
            isLoading: false,
            isLoadingFile: false,
            isPropuesta: false,
            observacion: {},
            observaciones: [],
            detalle: {},
            observacionDetalles: [],
            observacionDetalle: {},
            observacionSelect: {},
            url: '',
            url2: '',
            urlArchivo: '',
            urlArchivo2: '',
            errorBag: {},
            archivo: {},
            archivo2: {},
            password: {}
        };
    },
    methods: {
        // helper para recargas: siempre adjunta tipo=2024
        buildAjaxData(extra = {}) {
            return function (d) {
                d.tipo = 2024;
                Object.assign(d, extra);
            };
        },

        loadFile(input) {
            this.isLoadingFile = true;
            input = event.target;
            if (input.files && input.files[0]) {
                const fileInput = event.target.files[0];
                const fileType = fileInput.type;
                if (fileType !== 'application/pdf') {
                    this.$swal.fire({ icon: "error", title: "Oops...", text: "Solo se permiten archivos PDF!" });
                    this.isLoadingFile = false; return;
                }
                const reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                const data = new FormData();
                data.append('File', input.files[0]);
                this.ss.uploadFile(data)
                    .then(result => {
                        if (result.data.success) {
                            this.$bvToast.toast(result.data.msg, { title: 'Correcto', variant: 'info', autoHideDelay: 5000 });
                            this.isLoadingFile = false;
                            this.archivo.CapI = result.data.data;
                            this.storearchivo(this.archivo);
                        } else {
                            this.$bvToast.toast(result.data.msg, { title: 'Oops!', variant: 'danger', autoHideDelay: 5000 });
                        }
                        this.isLoadingFile = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$bvToast.toast('Error subiendo archivo', { title: 'Oops!', variant: 'danger', autoHideDelay: 5000 });
                        this.isLoadingFile = false;
                    });
            }
        },

        loadFile2(input) {
            this.isLoadingFile = true;
            input = event.target;
            if (input.files && input.files[0]) {
                const reader = new FileReader();
                reader.readAsDataURL(input.files[0]);
                const data = new FormData();
                data.append('File', input.files[0]);
                this.ss.uploadFile(data)
                    .then(result => {
                        if (result.data.success) {
                            this.$bvToast.toast(result.data.msg, { title: 'Correcto', variant: 'info', autoHideDelay: 5000 });
                            this.isLoadingFile = false;
                            this.archivo2.CapII = result.data.data;
                            this.storearchivo2(this.archivo2);
                        } else {
                            this.$bvToast.toast(result.data.msg, { title: 'Oops!', variant: 'danger', autoHideDelay: 5000 });
                        }
                        this.isLoadingFile = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.$bvToast.toast('Error subiendo archivo', { title: 'Oops!', variant: 'danger', autoHideDelay: 5000 });
                        this.isLoadingFile = false;
                    });
            }
        },

        showarchivo(id) {
            this.ss.showarchivo(id).then((result) => {
                let response = result.data;
                if (response.data == null) {
                    let item = { idEspecialidad: id };
                    this.storearchivo(item);
                } else {
                    this.archivo = response.data;
                }
                this.urlArchivo = this.url + this.archivo.CapI;
                this.$refs['view-FormularioObservacion'].show();
            }).catch(console.log);
        },

        unirPdf(id) {
            this.ss.unirPdf(id).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                const link = document.createElement('a');
                link.href = url; link.setAttribute('download', 'union.pdf');
                document.body.appendChild(link); link.click(); link.remove();
                window.URL.revokeObjectURL(url);
            }).catch(err => console.error('Error al descargar el PDF', err));
        },

        storearchivo(id) {
            this.ss.storearchivo(id).then((result) => {
                let response = result.data;
                this.archivo = response.data;
                this.urlArchivo = this.url + this.archivo.CapI;
            }).catch(console.log);
        },

        showarchivo2(id) {
            this.ss.showarchivo2(id).then((result) => {
                let response = result.data;
                if (response.data == null) {
                    let item = { idEspecialidad: id };
                    this.storearchivo2(item);
                } else {
                    this.archivo2 = response.data;
                }
                // usar url2 correctamente
                this.urlArchivo2 = this.url2 + this.archivo2.CapII;
                this.$refs['view-FormularioObservacion2'].show();
            }).catch(console.log);
        },

        storearchivo2(id) {
            this.ss.storearchivo2(id).then((result) => {
                let response = result.data;
                this.archivo2 = response.data;
                this.urlArchivo2 = this.url2 + this.archivo2.CapII;
            }).catch(console.log);
        },

        cargarFormulario(item) {
            this.observacionSelect = item;
            this.urlArchivo = this.url + this.observacionSelect.urlObservacion;
            this.$refs['view-FormularioObservacion'].show();
        },

        async getarchivo() {
            await new Promise(resolve => setTimeout(resolve, 2000));
            if (this.usuario.idEspecialidad) {
                let id = this.usuario.idEspecialidad;
                this.ajax.data = this.buildAjaxData({ idEspecialidad: id });
                this.$refs['datatable-ArchivoCapitulo'].reloadAjax(this.ajax);
            }
        },

        async getEspecialidad() {
            this.isLoading = true;
            let idEspecialidad = this.usuario.idEspecialidad;
            let idUnidadAcademica = this.usuario.UnidadAcademica;
            this.ajax.data = this.buildAjaxData({ idEspecialidad, idUnidadAcademica });
            await new Promise(resolve => setTimeout(resolve, 2000));
            this.$refs['datatable-ArchivoCapitulo'].reloadAjax(this.ajax);
            this.isLoading = false;
        },

        draw() {
            window.$('.btn-datatable-ArchivoCapituloI').on('click', (evt) => {
                let idEspecialidad = window.$(evt.target)[0].getAttribute('idEspecialidad');
                if (idEspecialidad) { this.showarchivo(idEspecialidad); }
                else {
                    this.$bvToast.toast('Ocurrio un problema inesperado, intente nuevamente.', {
                        title: 'Oops', variant: 'danger', autoHideDelay: 5000
                    });
                }
            });

            window.$('.btn-datatable-ArchivoCapituloII').on('click', (evt) => {
                let idEspecialidad = window.$(evt.target)[0].getAttribute('idEspecialidad');
                if (idEspecialidad) { this.showarchivo2(idEspecialidad); }
                else {
                    this.$bvToast.toast('Ocurrio un problema inesperado, intente nuevamente.', {
                        title: 'Oops', variant: 'danger', autoHideDelay: 5000
                    });
                }
            });

            window.$('.btn-datatable-unirpdf').on('click', (evt) => {
                let idEspecialidad = window.$(evt.target)[0].getAttribute('idEspecialidad');
                this.unirPdf(idEspecialidad);
            });
        }
    },
    components: { dataTable, Loader },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        if (!persona) {
            this.$router.push('/Login');
        } else {
            this.usuario = persona;
            this.url = process.env.VUE_APP_MAIN_SERVICE + 'storage/documents/';
            this.url2 = process.env.VUE_APP_MAIN_SERVICE + 'storage/documents/';
            this.getEspecialidad();
        }
    }
};
